import { AssignOptions } from "@/autogen/common";

export function upperSnakeToTitleCase(input?: string, acronyms: string[] = []) {
  if (!input) return "--";
  return input
    .split("_")
    .map((word) =>
      acronyms.includes(word)
        ? word
        : word.charAt(0) + word.slice(1).toLowerCase(),
    )
    .join(" ");
}

export function upperSnakeToTitleCaseOptional(
  input?: string,
  acronyms: string[] = [],
) {
  if (!input) return undefined;
  return input
    .split("_")
    .map((word) =>
      acronyms.includes(word)
        ? word
        : word.charAt(0) + word.slice(1).toLowerCase(),
    )
    .join(" ");
}

export function lowerCamelToTitle(str: string) {
  return (
    str
      // Insert space before capital letters
      .replace(/([A-Z])/g, " $1")
      // Capitalize first letter
      .replace(/^./, (char) => char.toUpperCase())
      .trim()
  );
}

export function updateIsNew(a: any, isNew: boolean) {
  a.isNew = isNew;
  a.isNewIsSet = isNew;
}

export function updateIsDeleted(a: any, isDeleted: boolean) {
  a.isDeleted = isDeleted;
  a.isDeletedIsSet = isDeleted;
}

export function isDeleted(a: any) {
  if (a.isDeletedIsSet && a.isDeleted) return true;
  return false;
}

export function isNew(a: any) {
  if (a.isNewIsSet && a.isNew) return true;
  return false;
}
